import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBackendApi from '../../../hooks/useBackendApi';
import GradientCircularProgressContainer from '../../../components/common/GradientCircularProgressContainer';

const QboDisconnect: React.FC = () => {
  const navigate = useNavigate();
  const { apiFetchRequest } = useBackendApi();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const disconnectQbo = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const slackId = urlParams.get('slack_id');

        const response = await apiFetchRequest({
          endpoint: '/api/angie/auth/quickbooks/connection',
          method: 'DELETE',
          body: { user_id: slackId },
        });

        if (response.isError) {
          throw new Error('Failed to disconnect');
        }

        setStatus('success');
      } catch (err) {
        console.error(err);
        setStatus('error');
      }
    };

    disconnectQbo();
  }, [apiFetchRequest]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {status === 'loading' && <GradientCircularProgressContainer loadingMessage="Disconnecting QuickBooks..." />}
      {status === 'success' && (
        <>
          <h2 className="text-2xl font-bold text-green-600 mb-4">You have successfully disconnected QuickBooks.</h2>
          <button onClick={() => navigate('/')} className="px-6 py-2 bg-blue-600 text-white rounded">
            Return to Dashboard
          </button>
        </>
      )}
      {status === 'error' && (
        <>
          <h2 className="text-2xl font-bold text-red-600 mb-4">Error disconnecting QuickBooks.</h2>
          <button onClick={() => navigate('/')} className="px-6 py-2 bg-gray-600 text-white rounded">
            Go Back
          </button>
        </>
      )}
    </div>
  );
};

export default QboDisconnect;
